import Container from 'react-bootstrap/Container'
import {Button, Card, Modal} from 'react-bootstrap'
import FormsGestionCases from './FormRecoverGestionCases'
import Common from '../componentCaseHistory'
import React, { useEffect, useState, Fragment} from 'react'
import { connect } from 'react-redux'
import Mensage from '../../components/common/mensage'
import ModalBitacora from '../../containers/modalBitacora'
import {useLocation, useNavigate } from 'react-router-dom'
import {CarpetaDigitalComponent, CambioTipoGestionComponent} from 'reccol-caso-general'

import {getCases, getFormLabel, postCasesBitacora, getCasesImplicated, cleanStateCase} from '../../store/actions'
import { Formik, Form } from 'formik'
import { validationSchemaForm } from '../../utils/validationSchema'
import { toast } from 'react-toastify'
import { Auth, LoadingComponent } from 'recupero-comunes'
import { CasoGeneralComponent } from 'defcol-caso-general'

const GetionCase = ({data, onGetGestionCases, onGetFormLabel, onPostBitacora, onGetGestionCasesImplicated, formLabel, onCleanState}) => {

  const history = useNavigate()
  const [show, setShow] = useState(false)
  const [showBitacora, setShowBitacora] = useState(false)
  const [loading, setLoading] = useState(false)
  const handleClose = () => setShow(false)
  const handleCloseBitacora = () => setShowBitacora(false)
  const [formValues, setFormValues] = useState()
  const { state } = useLocation()

  const { rutUsuario } = Auth.currentUser()
  // ---Parametros
  const idOrgano = state?.row?.idOrgBien ? state.row.idOrgBien : '8600399880'
  const idCaso = state?.row?.IdCaso ? state.row.IdCaso : 5
  const idImplicado = state?.row?.IdImplicado ? state.row.IdCaso : 0
  const areaTrabajo = state?.formValues ? state.formValues : {}

  const user = rutUsuario

  useEffect(() => {
    onGetGestionCases({
      idOrgCaso: idOrgano,
      idCaso: idCaso
    })
    onGetFormLabel()
    onGetGestionCasesImplicated({
      idOrgCaso: idOrgano,
      idCaso: idCaso
    })
  }, [])

  const options = {
    data: data?.cases[0],
    form: formLabel,
    dataImplicated: data?.implicated,
    idCaso,
    idOrgano,
    idImplicado
  }

  const initialValues = {
    idOrgCaso: data?.cases[0]?.Compania,
    idCaso: data?.cases[0]?.IdCaso,
    estadoCaso: '',
    observacion: '',
    usuario: user
  }

  const queryState=JSON.parse(localStorage.getItem('filtrosAreaGestion'))
  const onBack = () => {
    onCleanState()
    history('/area-gestion-compania', {
      state: {queryState}
    })
  }

  const onBitacora = () => {
    setShowBitacora(true)
  }

  const onSubmit = (values) => {
    setShow(true)
    setFormValues(values)
  }

  useEffect(() => {
    if (data.response) {
      toast(data.response)
      data.response = {}
    }
  }, [data.response])

  const onSubmitModal = async () => {
    setShow(false)
    await setLoading(true)
    try {
      await onPostBitacora(formValues)
    } catch (error) {
      toast.error(error)
    } finally {
      await setLoading(false)
      onBack()
    }
  }
  const [showCarpeta, setShowCarpeta] = useState(false)
  const handleShowCarpeta = () => setShowCarpeta(true)
  const handleCloseCarpeta= () => setShowCarpeta(false)
  
  const [showCambiar, setShowCambiar] = useState(false) 
  const handleCloseCambiar = () => {setShowCambiar(false)}
  const handleShowCambiar = () => setShowCambiar(true)

  return (
    <>
    <style type='text/css'>
    {`
    .btn-carpeta {
      background-color: #D59B49;
      color: #FFFFFF;
      width: 140px;
      
    }
    .btn-carpeta:hover{
        background-color:#e1b97f;
        color: #FFFFFF;

    }
    .btn-bitacora {
      background-color: #55B2CE;
      color: #FFFFFF;
      width: 140px;
    }
    .btn-bitacora:hover{
        background-color: #87c9dc;
        color: #FFFFFF;
    }
    .btn-recepcionar {
      background-color: #C14B49;
      color: #FFFFFF;
      width: 140px;

    }
    .btn-recepcionar:hover{
        background-color: #d3807f;
      color: #FFFFFF;
    }
    .btn-volver {
      color: #66CCCC;
      border: 1px solid #C00
      width: 140px;
    }
    .btn-tamano{
      padding: 1rem 1.5rem;
      font-size: 1.5rem;
    }
    .btn-cambiar {
      background-color:  #286FBF;
      color: #FFFFFF;
      width: 140px;     
      padding:6px 0px 6px 0px;
    }
    .btn-cambiar:hover{
        background-color:  #5b9ad1;
        color: #FFFFFF;
    }
    `}
    </style>
    <Modal show={showCarpeta} onHide={handleCloseCarpeta} size="xl">              
        <CarpetaDigitalComponent handleClose={handleCloseCarpeta} 
          idCaso={idCaso}
          idImplicado={idImplicado}
          idOrganizacionCaso={idOrgano}
          prototipo={2}            
          />     
    </Modal>
    <Modal show={showCambiar} onHide={handleCloseCambiar} size='xl'>
        <CambioTipoGestionComponent handleClose={handleCloseCambiar} 
        idCaso={idCaso}
        idImplicado={1}
        idOrganizacionCaso={idOrgano}
        />
    </Modal>
    
    <Container className='mt-2'>
      <LoadingComponent show={loading || data.loading || formLabel.loading} />
      {data?.cases.length > 0 &&
      Object.keys(formLabel?.formLabel).length > 0 ? (
        <Card className='mt-2'>
          {/*<Common {...options} />*/}
          <Card className='mt-2'>
            <Card.Header as='h6' className="text-center" style={{backgroundColor:"#4F517A", color:"white"}} >
              {formLabel?.formLabel['gestcasos-title']} {idCaso}
            </Card.Header>
            <Card.Body>
              <CasoGeneralComponent idCaso={idCaso} idImplicado={idImplicado} idOrganizacionCaso={idOrgano} /> 
            </Card.Body>
          </Card>
          <Card className='mt-2'>
            <Card.Header as='h6' className='m-2 border border-2' style={{backgroundColor:"#4F517A", color:"white"}} >
              {formLabel?.formLabel['gestcasos-subtitle']}
            </Card.Header>
            <Card.Body>
            <Formik
              className=' m-2 '
              initialValues={initialValues}
              onSubmit={onSubmit}
              validationSchema={validationSchemaForm}
            >
              <Form>
                <div
                  className='d-grid gap-2 d-md-block float-left m-4'
                  style={{
                    float: 'right'
                  }}
                >
                  <FormsGestionCases className='m-2' form={formLabel} />
                </div>
                <div
                  className='d-grid gap-2 d-md-block float-left mt-4 mb-2'
                  style={{
                    float: 'right'
                  }}
                >
                  <Button
                    className='m-2 w-auto'
                    variant='outline-info'
                    onClick={() => onBack()}
                  >
                    {formLabel?.formLabel['gestcasos-btn-volver']}
                  </Button>

                  <Button className='m-2' variant='carpeta' onClick={handleShowCarpeta}> 
                    {formLabel?.formLabel['gestcasos-btn-cd']}
                  </Button>

                  <Button className='m-2' variant='cambiar' onClick={handleShowCambiar}>
                    {formLabel?.formLabel['gestcasos-btn-cerrar']}
                  </Button>

                  <Button
                    className='m-2'
                    onClick={() => onBitacora()}
                    variant='bitacora'
                  >
                    {formLabel?.formLabel['gestcasos-btn-bitacora']}
                  </Button>

                  <Button className='m-2' type='submit' variant='recepcionar'>
                    {formLabel?.formLabel['gestcasos-btn-recepcionar']}
                  </Button>
                </div>
                {show && (
                  <Mensage
                    show={show}
                    handleClose={handleClose}
                    message='Esta Seguro que desea Recepcionar este Caso'
                    onSubmitModal={() => onSubmitModal()}
                  />
                )}
              </Form>
            </Formik>
            {showBitacora && (
              <ModalBitacora
                show={showBitacora}
                handleClose={handleCloseBitacora}
                idCaso={idCaso}
                rutcia={idOrgano}
                user
              />
            )}
            </Card.Body>
          </Card>
        </Card>
      ) : null}
    </Container>
    </>
  )
}

const mapStateToProps = (state) => ({
  data: state.cases,
  formLabel: state.formLabel
})

const mapDispatchToProps = (dispatch) => ({
  onGetGestionCases: (query) => dispatch(getCases(query)),
  onGetGestionCasesImplicated: (query) => dispatch(getCasesImplicated(query)),
  onGetFormLabel: () => dispatch(getFormLabel()),
  onPostBitacora: (body) => dispatch(postCasesBitacora(body)),
  onCleanState: () => dispatch(cleanStateCase())
})

export default connect(mapStateToProps, mapDispatchToProps)(GetionCase)
